/*
 * @providesModule TrophiesAheadToast.style
 * @format
 */

import {default as SkillzStyle} from 'SkillzStyle';
import {StyleSheet} from 'react-native';

const {fontBold, fontSizeH4, fontSizeH5} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  revampedTrophyToastContainer: {
    borderRadius: 25,
    ...SkillzStyle.fullStyles.px8,
    ...SkillzStyle.fullStyles.selfCenter,
    ...SkillzStyle.fullStyles.mt8,
    ...SkillzStyle.fullStyles.py4,
    marginHorizontal: 60,
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowOpacity: 0.8,
    shadowRadius: 12,
    elevation: 12,
    borderWidth: 0.5,
    borderColor: 'rgba(0, 255, 0, 0.1)',
  },

  nonExpandedContainer: {
    height: 60,
    width: 240,
  },

  expandedContainer: {
    height: 90,
    width: 380,
  },

  revampedTrophyToastContent: {
    ...SkillzStyle.fullStyles.flexRow,
    ...SkillzStyle.fullStyles.itemsCenter,
    ...SkillzStyle.fullStyles.justifyStart,
  },

  // 🎯 Non-Expanded Content Styles
  nonExpandedContent: {
    ...SkillzStyle.fullStyles.flexRow,
    ...SkillzStyle.fullStyles.itemsCenter,
    ...SkillzStyle.fullStyles.justifyBetween,
  },

  // 🎯 Expanded Content Styles
  expandedContent: {
    ...SkillzStyle.fullStyles.flexRow,
    ...SkillzStyle.fullStyles.itemsStart,
    marginLeft: -25,
    ...SkillzStyle.fullStyles.justifyStart,
  },

  revampedTrophyIconContainer: {
    ...SkillzStyle.fullStyles.mr1,
    ...SkillzStyle.fullStyles.justifyStart,
    ...SkillzStyle.fullStyles.itemsCenter,
  },

  // 🎯 Non-Expanded Icon Container Styles
  nonExpandedIconContainer: {
    ...SkillzStyle.fullStyles.mr1,
    ...SkillzStyle.fullStyles.justifyStart,
    ...SkillzStyle.fullStyles.itemsCenter,
  },

  // 🎯 Expanded Icon Container Styles
  expandedIconContainer: {
    ...SkillzStyle.fullStyles.mr2,
    ...SkillzStyle.fullStyles.py0,
    ...SkillzStyle.fullStyles.justifyCenter,
    ...SkillzStyle.fullStyles.itemsCenter,
  },

  // 🎯 Non-Expanded Image Styles
  nonExpandedImage: {
    width: 32, // Smaller image for non-expanded view
    height: 32,
  },

  // 🎯 Expanded Image Styles
  expandedImage: {
    width: 50,
    height: 50,
  },

  revampedTrophyText: {
    ...fontBold,
    ...fontSizeH4,
    // Color will be set dynamically based on theme
    ...SkillzStyle.fullStyles.textCenter,
  },

  // 🎯 Non-Expanded Text Container
  nonExpandedTextContainer: {
    ...SkillzStyle.fullStyles.flex1,
    ...SkillzStyle.fullStyles.justifyCenter,
    ...SkillzStyle.fullStyles.itemsCenter,
    ...SkillzStyle.fullStyles.py0,
  },

  // 🎯 Expanded Text Container
  expandedTextContainer: {
    ...SkillzStyle.fullStyles.flex1,
    ...SkillzStyle.fullStyles.justifyCenter,
    ...SkillzStyle.fullStyles.itemsStart,
    ...SkillzStyle.fullStyles.pt2,
    maxWidth: '80%',
  },

  revampedTrophyTextLine1: {
    ...fontBold,
    ...fontSizeH5,
    ...SkillzStyle.fullStyles.textLeft,
    ...SkillzStyle.fullStyles.mb1,
  },

  expandedContentRow: {
    ...SkillzStyle.fullStyles.flexRow,
    ...SkillzStyle.fullStyles.itemsCenter,
    ...SkillzStyle.fullStyles.justifyBetween,
    width: '100%',
    marginTop: -5,
  },

  progressBarContainer: {
    width: '100%',
    ...SkillzStyle.fullStyles.mt1,
    ...SkillzStyle.fullStyles.mb0,
    ...SkillzStyle.fullStyles.ml0,
  },

  progressBarBackground: {
    height: 10,
    backgroundColor: 'transparent',
    borderRadius: 5,
    overflow: 'hidden',
    position: 'relative',
  },

  progressBarFill: {
    height: '100%',
    backgroundColor: '#851556',
    borderRadius: 5,
  },

  progressBarFillGradient: {
    height: '100%',
    width: '100%',
    borderRadius: 5,
  },

  progressBarUnfilled: {
    position: 'absolute',
    height: '100%',
    right: 0,
    backgroundColor: '#E6E6FA',
    borderRadius: 5,
    width: '100%',
  },

  chevronIcon: {
    width: 24,
    height: 24,
    marginLeft: 16,
    marginRight: 40,
    zIndex: 1000,
    ...SkillzStyle.fullStyles.selfCenter,
  },

  initialTextContainer: {
    ...SkillzStyle.fullStyles.itemsCenter,
    ...SkillzStyle.fullStyles.justifyCenter,
  },

  gradientOverlay: {
    ...SkillzStyle.fullStyles.absoluteFill,
    borderRadius: 25,
  },

  claimButton: {
    marginBottom: 20,
    ...SkillzStyle.fullStyles.flexRow,
    backgroundColor: '#851556',
    borderRadius: 8,
    ...SkillzStyle.fullStyles.px4,
    ...SkillzStyle.fullStyles.py2,
    ...SkillzStyle.fullStyles.mt1,
    ...SkillzStyle.fullStyles.selfStart,
    shadowOffset: {
      width: 0,
      height: 2,
    },
  },

  claimButtonText: {
    ...fontBold,
    ...fontSizeH4,
    ...SkillzStyle.fullStyles.textCenter,
  },
  giftIcon: {
    height: 20,
    width: 20,
    ...SkillzStyle.fullStyles.mr1,
    marginTop: 2,
  },
});
